import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import Seo from './components/Seo/Seo';
import './App.css';

const AuthApp = () => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: audience,
        redirect_uri: `${window.location.origin}/app`,
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <Seo title="Screenplayer – Sign in" path="/app" noindex />
      <App />
    </Auth0Provider>
  );
};

export default AuthApp;